define('DoubleUnitSales.View'
	, [
		'tavanoteam_doubleunitsales_doubleunitsales.tpl'
		, 'Utils'
		, 'Backbone'
		, 'jQuery'
		, 'underscore'
		, 'TavanoTeam.DoubleUnitSales.Model'
		, 'Profile.Model'
	]
	, function (
		tavanoteam_doubleunitsales_doubleunitsales_tpl
		, Utils
		, Backbone
		, jQuery
		, _
		, DoubleUnitSalesModel
		, ProfileModel
	) {
		'use strict';

		return Backbone.View.extend({


			template: tavanoteam_doubleunitsales_doubleunitsales_tpl,

			events: {
				'change [data-action="change-quantity"]': 'changeQuantity'
			},

			initialize: function (options) {
				this.itemInfo = options.pdp.getItemInfo();

				var profile = ProfileModel.getInstance()
				var isLoggedIn = profile.get('isLoggedIn');
				var customerId = isLoggedIn == 'T' ? profile.id : "";

				this.model = new DoubleUnitSalesModel();

				var self = this;
				var inventoryId = this.itemInfo.item.internalid;
				//var itemid = this.itemInfo.item.itemid;

				this.model.fetch({
					data: { id: inventoryId, customerId: customerId }
				})
					.done(function (response) {

						self.render();
					});

				this.quantity = this.itemInfo.item.quantityavailable;
				this.conversionFactor = this.itemInfo.item.custitem_conversion_factor;

				this.isCustomPrice = false;

				this.updatedPrice = ''

			}

			,

			getPrice: function getPrice(price) {
				var actualPrice = "";
				_.each(this.model.attributes, function (element, i) {

					if (element.pricelevelname == price) {
						actualPrice = element;
					}
					
					var totalIncluded = false;
					
					var priceArr = price.split(' ')
					for (var i = 0; i < priceArr.length; i++) {
						if (priceArr[i] == '100%') {
							totalIncluded = true;
						}
					}

					if (element.pricelevelname == "MSRP (Base Price)" && totalIncluded) {
						actualPrice = element;
					}
				});
				return actualPrice;
			}
			, defineData: function defineData(doubleRate) {
				var data = [];
				var type = this.model.attributes[0];

				if (this.itemInfo.item.custitem_set_online_price_1_to_cfpl) {
					var level = type && type.customerLevel ? type.customerLevel : this.itemInfo.item.custitem_set_online_price_1_to_cfpl;
					var caseOnlinePrice = this.getPrice(level);
					var caseMsrp = this.getPrice("MSRP (Base Price)");

					var unit = "";
					if (type && type.abbrevnUnitsType) {
						unit = doubleRate ? type.abbrevnUnitsType.split(' ')[2] : type.abbrevnUnitsType.split(' ')[0];
					}
					var msrp = doubleRate ? (caseMsrp.price_2_ * doubleRate[1]) : caseMsrp.price_1_;
					var price = doubleRate ? (caseOnlinePrice.price_2_ * doubleRate[1]) : caseOnlinePrice.price_1_;
					var onHand = false;

					if (this.quantity / this.conversionFactor > 1) {
						onHand = true;
					};

					if (this.model.attributes[0]) {

						if (this.model.attributes[0].isCustom !== undefined && this.model.attributes[0].isCustom !== '') {

							price = this.model.attributes[0].isCustom * this.conversionFactor;

						}

					}
					var itemCase = {
						unit: unit,
						msrp: msrp ? this.numberWithCommas(msrp, true) : "",
						price: price ? this.numberWithCommas(price, true) : "",
						stock: this.itemInfo.item.isinstock ? "In Stock" : "Inquire",
						noStock: !this.itemInfo.item.isinstock,
						onHand: onHand,
						level: "1-" + level,

						quantity: type ? type.abbrevnUnitsType.split(" or ").length > 1 ? (doubleRate ? 1 : "") : 1 : ""
					}
					data.push(itemCase);
				}

				if (this.itemInfo.item.custitem_set_online_price_2_to_cfpl && !this.itemInfo.item.custitem_store_hide_lower_uom) {
					var level = type && type.customerLevel ? type.customerLevel : this.itemInfo.item.custitem_set_online_price_2_to_cfpl;
					var eachOnlinePrice = this.getPrice(level);
					var eachMsrp = this.getPrice("MSRP (Base Price)");
					var unit = "";
					if (type && type.abbrevnUnitsType) {
						unit = type.abbrevnUnitsType.split(' ')[0];
					}
					var msrp = eachMsrp.price_1_;
					var price = eachOnlinePrice.price_1_;
					var onHand = false
					if (this.quantity > 0) {
						onHand = true;
					};

					if (this.model.attributes[0]) {

						if (this.model.attributes[0].isCustom !== undefined && this.model.attributes[0].isCustom !== '') {

							price = this.model.attributes[0].isCustom;

						}

					}
					var itemEach = {
						unit: unit,
						msrp: msrp ? this.numberWithCommas(msrp, true) : "",
						price: price ? this.numberWithCommas(price, true) : "",
						stock: this.itemInfo.item.isinstock && this.itemInfo.item.quantityavailable >= 4 ? "In Stock" : "Inquire",
						level: "2-" + level,
						onHand: onHand
					}
					data.push(itemEach);
				}
				return data;

			}
			, changeQuantity: function changeQuantity(e) {
				e.preventDefault();
				var target = this.$(e.target);
				
				var attr = target.attr('id')
				var value = target.val();
				var type = this.model.attributes[0];
				if (target) {
					target.find('[data-validation-error="block"]').remove();
				}

				if (value < 1) {
					this.$('#invalid-qty').remove();
				}

				var unit = attr.split("-")[0];

				var selectedPrice =  parseFloat(this.$('#' + unit + '-price').text().replace(/,/g, ''));

				this.updatedPrice = (parseFloat(value) * selectedPrice).toFixed(2);
				
				$('.product-views-price-lead').text(this.updatedPrice);
				
				var isDouble = type.rateUnitsType.length > 1;
				if (value != '' && value > 0) {
					if (isDouble) {
						var split = type.abbrevnUnitsType.split(' or ');
						var type = '#' + split[0] + '-quantity';

						jQuery(type).val('');

						type = '#' + split[1] + '-quantity';

						jQuery(type).val('');
						
						type = '#' + attr;
						jQuery(type).val(value);
					}
					jQuery("#unit-level").val(attr.split('-')[0]);

					$("#invalid-qty").hide();
				} else {
					$("#invalid-qty").show();
				}
				
			},
			numberWithCommas: function numberWithCommas(x, isDoubleUnit) {
				var price = x;
				if (isDoubleUnit) {
					
					price = parseFloat(price).toFixed(2)
				}

				return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			},

			getContext: function getContext() {

				var type = this.model.attributes[0];
				var unitstype = type && type.pluralUnitsType ? type.pluralUnitsType : '';
				var isDouble = type && type.rateUnitsType && type.rateUnitsType.length > 1 ? type.rateUnitsType : false;
				unitstype = isDouble ? this.itemInfo.item.custitem_store_hide_lower_uom ? unitstype.split(' ')[2] : unitstype.split(' (')[0] : unitstype;

				var onHand = false;

				// Show Warning Tab anchor scroll icon
				var wariningTab = !!this.itemInfo.item.custitem_tt_warning_message_ta;

				var data = this.defineData(isDouble);
				var level = this.model.attributes[0] && this.model.attributes[0].customerLevel ? this.model.attributes[0].customerLevel : this.itemInfo.item.custitem_set_online_price_1_to_cfpl;
				var caseOnlinePrice = this.getPrice(level);
				var isAddToCartActive = this.itemInfo.item ? this.itemInfo.item.custitem_item_master_status == "Active Item Displayed With Price" : "";
				var price = isDouble ? (caseOnlinePrice.price_2_ * isDouble[1]) : caseOnlinePrice.price_1_;

				if (price)
					price = (Math.round((price) * 100) / 100).toFixed(2)

				var unitLevel = type ? type.abbrevnUnitsType.split(' or ') : "";
				if (unitLevel) {
					unitLevel = unitLevel.length > 1 ? unitLevel[1] : unitLevel[0];
				}
				
				if (this.model.attributes[0]) {
					
					if (this.model.attributes[0].isCustom !== undefined && this.model.attributes[0].isCustom !== '') {
						price = isDouble ? (this.model.attributes[0].isCustom * this.conversionFactor) : this.model.attributes[0].isCustom;
						price = price.toFixed(2);
					}

				}
				
				return {
					doubleUnit: data,
					unitstype: unitstype,
					price: price ? this.numberWithCommas(price) : "",
					isPricingActive: isAddToCartActive,
					unitLevel: unitLevel,
					onHand: onHand,
					updatedPrice: price ? this.numberWithCommas(price) : "",
					wariningTab: wariningTab // Show Warning Tab anchor scroll icon
				};
			},
		});
	});
